import React from 'react';

const AdminSettings = () => {
  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <h1>Settings</h1>
        <p>Configure site settings</p>
      </div>
      <div className="admin-page-content">
        <div className="empty-state-card">
          <p>⚙️ Settings management coming soon</p>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;
